import ToomarUnderlineSmooth from "../../assets/toomarUnderlineSmooth.svg";

export default function GalleryOrder({ onClick, text, active, icon }) {
  return (
    <div onClick={onClick}>
      <p className={active ? "isActive" : "isNotActive"}>{text}</p>
      {active && <img src={ToomarUnderlineSmooth} alt={"کارت عروسی"} /> }
      <div></div>
    </div>
  );
}
